import moment from "moment"


export const toDate = () => {
    return moment().add(1, 'year').endOf('year')
}

export const toDateNew = () => {
    return moment().add(2, 'year').endOf('year')
}